export default __webpack_public_path__ + "static/media/X.1dee687d.svg";